import type { PortalAudience } from '@/access/portalAccess.types';
import { CLIENT_FILTER_KEYS } from '@/modules/clients/components/utils/clientFilters.utils';
import type { ClientsViewInput } from '@/modules/clients/clients.viewInput';

export type ClientFilterKey = (typeof CLIENT_FILTER_KEYS)[number];

export type ClientsListQueryType = 'tenant';

export type ClientsListView = {
  audience: PortalAudience;
  filterKeys: ClientFilterKey[];
  actions: {
    showSearch: boolean;
    showAddClient: boolean;
  };
  query: {
    clients: {
      strategy: ClientsListQueryType;
    };
  };
};

export const getClientsListView = ({
  access,
}: ClientsViewInput): ClientsListView => {
  const { audience } = access;

  return {
    audience,
    filterKeys: [...CLIENT_FILTER_KEYS],
    actions: {
      showSearch: true,
      showAddClient: true,
    },
    query: {
      clients: {
        strategy: 'tenant',
      },
    },
  };
};
